<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="!dataForm.projectId ? '新增' : '编辑'" width="680px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="150px" v-loading="dialogLoading">
      <!-- <el-form-item prop="contractId" label="关联合同">
        <el-select style="width: 100%;" v-model="dataForm.contractId" :disabled="dataForm.id" placeholder="请选择关联合同" filterable autocomplete="off" clearable>
          <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="clientContactPerson" label="联系人">
        <el-input v-model="dataForm.clientContactPerson" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item prop="clientContactPhoneNumber" label="联系电话">
        <el-input v-model="dataForm.clientContactPhoneNumber" :disabled="dataForm.id" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item prop="clientAddressLongitude" label="经纬度">
        <el-input style="width: 200px" v-model="dataForm.clientAddressLongitude" autocomplete="off" placeholder="请输入经度" clearable ></el-input>
        &ensp;
        <el-input style="width: 200px" v-model="dataForm.clientAddressLatitude" autocomplete="off" placeholder="请输入纬度" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="clientAddress" label="地址信息">
        <el-cascader style="width: 100%;" :props="props" :options="options" v-model="dataForm.clientAddress" clearable ></el-cascader>
      </el-form-item>
      <el-form-item prop="clientAddressDetail" label="详细地址">
        <el-input v-model="dataForm.clientAddressDetail" :disabled="dataForm.id" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    contactList: Array
  },
  data () {
    var getDress = keywords => {
      let subdistrict = keywords ? "1" : "0";
      return axios.get(
        "https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=" +
        keywords +
        "&subdistrict=" +
        subdistrict +
        "&extensions=base"
      );
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      projectId: '',
      serversList: [],
      clientServersList: [],
      options: [],
      props: {
        //配置级联选择器
        label: "name",
        children: "districts",
        value: "name",
        expandTrigger: "hover",
        // checkStrictly: true, //建立级联选择器父子间的关联，从而可以选择任意一级
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let nodes;
          setTimeout(() => {
            getDress(node.label ? node.label : "").then(res => {
              nodes = res.data.districts[0].districts;
              resolve(nodes);
            });
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          }, 100);
        }
      },
      dataForm: {
        clientContactPerson: '',
        clientContactPhoneNumber: '',
        clientAddressLatitude: '',
        clientAddressLongitude: '',
        clientAddress: [],
        clientAddressDetail: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        clientContactPerson: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientContactPhoneNumber: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientAddressLatitude: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientAddressLongitude: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientAddress: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clientAddressDetail: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row, projectId) {
      this.visible = true
      this.projectId = projectId
      this.dataForm = {
        clientContactPerson: '',
        clientContactPhoneNumber: '',
        clientAddressLatitude: '',
        clientAddressLongitude: '',
        clientAddress: [],
        clientAddressDetail: ''
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        axios.get("https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=&subdistrict=0&extensions=base").then((res) => {
          if (res) {
            this.options = res.data.districts
          }
        })
        if (row !== null) {
          this.dataForm = Object.assign({}, row)
          this.dataForm.clientAddress = this.dataForm.clientAddress.split('/')
        }
        console.log(this.dataForm)
      })
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.dataForm.clientAddress = this.dataForm.clientAddress.join('/')
        if (this.dataForm.projectId) {
          this.$api.contract.modifyClientContactInfo({ ...this.dataForm, projectId: this.projectId }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        } else {
          this.$api.contract.addClientContactInfo({ ...this.dataForm, projectId: this.projectId }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        }
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
}
</style>
